import { GetFieldForFilterAndSort } from '../Util/Field';

const NotificationCollectionFields = [
	GetFieldForFilterAndSort(
		"CreatedOn",
		"Created On",
	),
];

export default NotificationCollectionFields;